import { useState } from 'react';
import { CheckIcon, QuestionMarkCircle } from '../../../icons/SvgIcons';
import { CheckboxProps } from './Checkbox.types';

function CheckboxItem({
  label,
  value,
  checked,
  onChange,
  labelClasses = 'flex items-center gap-2',
  wrapperClasses = 'relative',
  textClasses,
  disabled = false,
  hint,
}: CheckboxProps) {
  const [hovered, setHovered] = useState(false);

  const handleChange = () => {
    onChange(value, !checked);
  };

  return (
    <div className="flex gap-2">
      <label
        className={`w-fit group text-left ${
          disabled ? 'cursor-default' : 'cursor-pointer'
        } ${labelClasses}`}
      >
        <div className={wrapperClasses}>
          <input
            type="checkbox"
            value={value}
            checked={checked}
            onChange={handleChange}
            className="sr-only peer"
            disabled={disabled}
          />
          <div
            className={`w-4 h-4 rounded border flex items-center justify-center
            ${
              checked
                ? disabled
                  ? 'bg-gray-100 border-gray-200 cursor-default'
                  : 'bg-purple-600 border-primary-400'
                : 'border-gray-200'
            }
            ${
              disabled
                ? 'cursor-default bg-gray-100'
                : 'group-hover:border-purple-800 interactive_ring_classes'
            }`}
          >
            {checked && CheckIcon(disabled ? '#767681' : 'white')}
          </div>
        </div>
        <span
          className={`text-gray-900v2 font-inter font-normal text-base leading-6 ${textClasses}`}
        >
          {label}
        </span>
      </label>
      {hint && (
        <div
          title={hint}
          className="mb-2"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {QuestionMarkCircle(hovered)}
        </div>
      )}
    </div>
  );
}

export default CheckboxItem;
